<a [href]="url" target="_blank" rel="noopener noreferrer" class="hidden" #fileLink *appPermissionRequired="'Clinical.Uploads.Read'">Open File</a>
